@if (loading) {
  <div class="alert-preview-stack__status">
    <mat-spinner diameter="32"></mat-spinner>
  </div>
} @else if (hasError) {
  <div class="alert-preview-stack__status">Could not load live alerts. Please try again.</div>
} @else if (alerts.length === 0) {
  <div class="alert-preview-stack__status">No live alerts right now.</div>
} @else {
  <div class="alert-preview-stack__stack">
    @for (alert of alerts; track alert.id) {
      <div
        class="alert-preview-stack__card"
        [style.--card-color]="levelMeta(alert.level).color"
        [ngClass]="'sgl-alert-' + levelMeta(alert.level).label">
        <mat-icon
          class="alert-preview-stack__card-icon material-symbols-outlined"
          [style.color]="levelMeta(alert.level).color">
          {{ levelMeta(alert.level).icon }}
        </mat-icon>
        <div class="alert-preview-stack__card-body">
          <span class="alert-preview-stack__card-level" [style.color]="levelMeta(alert.level).color">
            {{ levelMeta(alert.level).label }}
          </span>
          <p class="alert-preview-stack__card-message">{{ alert.message }}</p>
          @if (alert.linkText && alert.linkUrl) {
            <a class="alert-preview-stack__card-link" [href]="alert.linkUrl" target="_blank" rel="noopener">
              {{ alert.linkText }} »
            </a>
          }
        </div>
        <button
          type="button"
          class="alert-preview-stack__card-close"
          [attr.aria-label]="'Close: ' + alert.message"
          (click)="dismiss.emit(alert.id)">
          &times;
        </button>
      </div>
    }
  </div>
}
